import classNames from 'classnames'

import style from './style.scss'

type Props = {
  className?: string
  children: React.ReactNode
}

function FilterBar({ className, children }: Props) {
  return <div className={classNames(style.wrapper, className)}>{children}</div>
}

export default FilterBar
